// Aviso "sin coste USD" al generar pedidos a proveedor: cuando una línea no
// tiene NINGUNA fuente de coste en el sistema (ni cotización, ni ficha de
// proveedor, ni pedidos previos), el pedido se crea con el coste vacío y hay
// que rellenarlo a mano. Este helper formatea el bloque de aviso que se añade
// a la confirmación de los cuatro flujos que generan pedidos.

export interface PedidosProveedorResumen {
  sin_coste?: number;
  sin_coste_lineas?: string[];
}

const MAX_LINEAS_VISIBLES = 5;

export function avisoSinCoste(pp: PedidosProveedorResumen | null | undefined): string {
  if (!pp?.sin_coste) return '';
  const lineas = pp.sin_coste_lineas ?? [];
  const visibles = lineas.slice(0, MAX_LINEAS_VISIBLES);
  const resto = lineas.length - visibles.length;
  const detalle = visibles.map((l) => `  · ${l}`).join('\n')
    + (resto > 0 ? `\n  · … y ${resto} más` : '');
  return `\n\n⚠ ${pp.sin_coste} pedido(s) SIN COSTE USD (ninguna fuente de coste en el sistema — rellénalo en la ficha del pedido a proveedor):\n${detalle}`;
}
